import * as React from 'react';
import * as Yup from 'yup';

import { Formik, FormikActions, FormikProps } from 'formik';
import { processApiError } from 'common/utils/form';

import { Member } from 'common/api/models/Member';
import { MemberApi } from 'common/api/resources/MemberApi';
import { FormInput } from 'common/components/form/FormInput';

interface PasswordFormProps {
  user: Member;
}
class PasswordFormValues {
  oldPassword = '';
  newPassword = '';
  confirmPassword = '';
}

// from https://github.com/jquense/yup/issues/97
function equalTo(ref: any, msg: any) {
  return Yup.mixed().test({
    name: 'equalTo',
    exclusive: false,
    message: msg || '${path} must be the same as ${reference}',
    params: {
      reference: ref.path,
    },
    test: function(value: any) {
      return value === this.resolve(ref);
    },
  });
}

Yup.addMethod(Yup.string, 'equalTo', equalTo);

export class PasswordForm extends React.Component<PasswordFormProps> {
  validationSchema = Yup.object().shape({
    oldPassword: Yup.string().required('Required'),
    newPassword: Yup.string()
      .min(8, 'Password must be at least 8 characters')
      .matches(/[0-9]/, 'Password must contain at least one number')
      .required('Required'),
    confirmPassword: Yup.string()
      .equalTo(Yup.ref('newPassword'), 'Passwords must match')
      .required('Required'),
  });

  initialValues() {
    return new PasswordFormValues();
  }

  handleSubmit = (values: PasswordFormValues, actions: FormikActions<PasswordFormValues>) => {
    MemberApi.changePassword(this.props.user.id!, {
      oldPassword: values.oldPassword,
      newPassword: values.newPassword,
    }).then(
      res => {
        actions.setSubmitting(false);
        actions.setStatus({ success: true });
      },
      err => {
        processApiError<PasswordFormProps, PasswordFormValues>(err, actions);
      }
    );
  };

  render() {
    return (
      <Formik
        initialValues={this.initialValues()}
        validationSchema={this.validationSchema}
        onSubmit={this.handleSubmit}
        render={(form: FormikProps<PasswordFormValues>) => (
          <form onSubmit={form.handleSubmit} style={{ textAlign: 'left' }}>
            <FormInput
              id="oldPassword"
              name="oldPassword"
              type="password"
              label="Current Password"
              autoComplete="off"
            />
            <FormInput id="newPassword" label="New Password" name="newPassword" type="password" autoComplete="off" />
            <FormInput
              id="confirmPassword"
              label="Confrim Password"
              name="confirmPassword"
              type="password"
              autoComplete="off"
            />
            <div className="row" style={{ marginTop: 10, textAlign: 'right' }}>
              <div className="col">
                <button className="btn btn-primary">Change Password</button>
              </div>
            </div>
            {form.status &&
              form.status.success && (
                <div className="row" style={{ marginTop: 20 }}>
                  <div className="col">
                    <div className="alert alert-success">Your password has been changed.</div>
                  </div>
                </div>
              )}
            {form.status &&
              !form.status.success && (
                <div className="row" style={{ marginTop: 20 }}>
                  <div className="col">
                    <div className="alert alert-danger">{form.status}</div>
                  </div>
                </div>
              )}
          </form>
        )}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/screens/UserSettings/PasswordForm.tsx